import React from 'react';
import { Download } from '../../assets/icons';
import PropTypes from 'prop-types';
import './AccountItem.scss';

const AccountItem = (props) => {
  return (
    <div className='accitem'>
      <p className='accitem__date'>{props.date}</p>
      <p className='accitem__statement'>{props.statement}</p>
      <div className='accitem__download' onClick={props.action}>
        <Download verticalAlign='-4px' color='#4F3D38' />
      </div>
    </div>
  );
};

AccountItem.propTypes = {
  date: PropTypes.string,
  statement: PropTypes.string,
  action: PropTypes.func,
};

export default AccountItem;
